/* Sukarah family product (TASK-143): in-place shade selection on a family PDP.
   The family page stays loaded; selecting a shade only toggles which child
   product's server-rendered panel (price, availability, its own ATC form) is
   visible. No navigation, no fetching — every child panel ships with the page.
   Deep links: /products/<family>?shade=<key> preselects; selection updates the
   `shade` query parameter via history.replaceState (other params preserved). */

if (!window.customElements.get('sukarah-family-buy')) {
  class SukarahFamilyBuy extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (event) => {
        const tile = event.target.closest('[data-family-shade]');

        if (tile && this.contains(tile)) {
          this.select(tile.getAttribute('data-family-shade'), { updateUrl: true });
        }
      });

      const requested = new URLSearchParams(window.location.search).get('shade');

      if (requested) {
        this.select(requested, { updateUrl: false });
      }
    }

    select(key, { updateUrl }) {
      if (!key) return;

      const tile = this.querySelector(`[data-family-shade="${CSS.escape(key)}"]`);
      const panel = this.querySelector(`[data-family-panel="${CSS.escape(key)}"]`);

      if (!tile || !panel) return; /* unknown key (bad deep link): keep default */

      this.querySelectorAll('[data-family-shade]').forEach((el) => {
        const isCurrent = el === tile;
        el.classList.toggle('is-selected', isCurrent);
        el.setAttribute('aria-pressed', isCurrent ? 'true' : 'false');
      });

      this.querySelectorAll('[data-family-panel]').forEach((el) => {
        el.hidden = el !== panel;
      });

      const nameEl = this.querySelector('[data-family-shade-name]');

      if (nameEl) {
        nameEl.textContent = tile.getAttribute('data-shade-label') || '';
      }

      if (updateUrl && window.history?.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set('shade', key);
        window.history.replaceState({}, '', url);
      }
    }
  }

  window.customElements.define('sukarah-family-buy', SukarahFamilyBuy);
}
